import React, { useEffect, useState } from 'react';
import { View, Text, Image, ScrollView, TouchableOpacity, FlatList, useWindowDimensions } from 'react-native-web';
import * as Animatable from 'react-native-animatable';

// APIs
import { getResourceCategories } from '../../modules/api_resources';

// Utils
import { toTitleCase } from '../../utils/util_helpers';

// Configs
import GLOBAL from '../../configs/config_global';
import LoadingView from '../../components/component_loading_view';
import { Button, NavBar } from '../../components';
import { useRoute } from '@react-navigation/native';
import RenderHtml, { defaultHTMLElementModels, HTMLContentModel } from 'react-native-render-html';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';

export function ResourceDetails() {
    const { topicData } = useRoute()?.params || {};

    const { width } = useWindowDimensions();
    const PADDING_VALUE = 32;
    const PHOTO_SIZE = 250;

    // region Local State
    const [isLoading, setLoading] = useState(false);
    const [photoOpened, setPhotoOpened] = useState(false);
    // endregion

    // region Component Mounting
    useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
    }, []);
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ width: '100%', flex: 1, backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }}>
            {/* Nav Bar */}
            <NavBar title={'Resource'} subTitle={topicData?.name} />

            {/* Main Content */}
            {
                isLoading ?
                    <LoadingView style={{ backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }} />
                    :
                    <ScrollView
                        style={{ flex: 1, width: '100%', backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }}
                        contentContainerStyle={{ alignItems: 'center', padding: PADDING_VALUE }}>
                        <View
                            style={{
                                alignSelf: 'stretch', alignItems: 'center', borderRadius: 8, borderWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER,
                                overflow: 'hidden', backgroundColor: 'white', padding: PADDING_VALUE
                            }}>
                            {/* Photo */}
                            {
                                !!topicData['featured_image'] &&
                                <TouchableOpacity onPress={() => setPhotoOpened(true)}>
                                    <Image
                                        source={{ uri: topicData['featured_image'] }}
                                        style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, marginBottom: 32 }}
                                        resizeMode={'cover'}
                                    />
                                </TouchableOpacity>
                            }

                            {/* Text */}
                            <RenderHtml
                                contentWidth={width - (PADDING_VALUE * 2) - (PADDING_VALUE * 2)}
                                source={{ html: !topicData.description.startsWith('<p>') ? topicData.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : topicData.description }}
                                baseStyle={{ lineHeight: 26, fontSize: 16 }}
                                defaultTextProps={{ allowFontScaling: false }}
                                enableExperimentalBRCollapsing={true}
                                enableExperimentalGhostLinesPrevention={true}
                                customHTMLElementModels={{
                                    'label': defaultHTMLElementModels.label.extend({ contentModel: HTMLContentModel.block }),
                                    'colgroup': defaultHTMLElementModels.colgroup.extend({ contentModel: HTMLContentModel.block }),
                                    'col': defaultHTMLElementModels.col.extend({ contentModel: HTMLContentModel.block })
                                }}
                            />

                            {/* CTA Button */}
                            {
                                !!topicData['cta_link']?.trim() &&
                                <Button
                                    onPress={() => window.open(topicData['cta_link'], '_blank')}
                                    style={{
                                        width: '50%', backgroundColor: 'white', borderWidth: 2, borderColor: GLOBAL.COLOR.DIVIDER,
                                        alignSelf: 'center',
                                        marginTop: PADDING_VALUE
                                    }}
                                    text={'Open'}
                                    textStyle={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO }}
                                    image={'external-link'}
                                    imageSize={24}
                                    imageColor={GLOBAL.COLOR.BASIC.BLACK_TWO}
                                    imageStickToText={true}
                                    useFeather={true}
                                />
                            }

                            {/* Lightbox - Photo */}
                            <Lightbox
                                open={photoOpened}
                                close={() => setPhotoOpened(false)}
                                slides={[{ src: topicData['featured_image'] }]}
                                carousel={{ imageFit: 'contain', finite: true }}
                                styles={{ container: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
                                render={{ buttonPrev: () => false, buttonNext: () => false }}
                            />
                        </View>
                    </ScrollView>
            }
        </View>
    );
    // endregion
}
